import useDidMountEffect from "@/customHooks/useDidMountEffect";
import { useEventsMutation, useLazyGetHiddenEventsQuery, useLazyGetSwarmsQuery, useUnhideAllEventsMutation } from "@/services/swarmsApi";
import { useEffect, useRef, useState } from "react";

function createFilterColumns(filters) {
  let res = [];
  if (filters.eventName) {
    res.push({
      Name: "name",
      filterType: filters.eventName.startsWith('*') ? "contains" : "startsWith",
      logicConditionType: "and",
      condition: filters.eventName.startsWith('*') ? filters.eventName.substring(1) : filters.eventName,
    })
  }

  if (filters.eventVenue) {
    res.push({
      Name: "venue",
      filterType: filters.eventVenue.startsWith('*') ? "contains" : "startsWith",
      logicConditionType: "and",
      condition: filters.eventVenue.startsWith('*') ? filters.eventVenue.substring(1) : filters.eventVenue,
    })
  }

  if (filters.saleDateToday) {
    res.push({
      Name: "salesdate",
      filterType: "contains",
      logicConditionType: "and",
      condition: (new Date()).toISOString().split("T")[0],
    })
  } else if (filters.eventDate) {
    //A: the user is searching for a specific date
    res.push({
      Name: "salesdate",
      filterType: "contains",
      logicConditionType: "and",
      condition: filters.eventDate.split("T")[0],
    })
  } else {
    //A: default time range
    res.push(
      {
        Name: "date",
        filterType: "greaterThan",
        logicConditionType: "and",
        condition: new Date().toISOString(),
      },
      {
        Name: "date",
        filterType: "smallerThan",
        logicConditionType: "and",
        condition: new Date(Date.now() + 5 * 365 * 24 * 60 * 60 * 1000).toISOString(),
      },
    )
  }

  
  if (filters.hiddenEvents && filters.hiddenEvents.length > 0) {
    res.push({
      Name: "bteids",
      filterType: "notcontains",
      logicConditionType: "and",
      condition: JSON.stringify(filters.hiddenEvents)
    })
  }

  console.log('_filters: ', res)
  return res;
};


const useFilters = ({setLocalEvents}) => {

  const [filters, setFilters] = useState({ saleDateToday: true });
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });

  const [getHiddenEvents, { data: hiddenEvents }] = useLazyGetHiddenEventsQuery();
  const [unhideEvents] = useUnhideAllEventsMutation();
  const [getSwarmEvents, { data: swarmEventsRes, isLoading: loadingEvents, isError: ErrorLoadingEvents, }] = useEventsMutation();
  const [getSwarms, { data: swarmsQueryData, isError: errorGettingSwarms, }] = useLazyGetSwarmsQuery();


  useEffect(() => {
    const initializeState = async () => {
      const dfltState = JSON.parse(sessionStorage.getItem("create-swarms-state"));

      setFilters((prev) => dfltState?.filters ?? prev);
      setPaginationModel((prev) => dfltState?.paginationModel ?? prev);

      const events = await getHiddenEvents().unwrap();

      const filtersModel = dfltState?.filters ?? filters;
      const modifiedModel = {
        ...filtersModel,
        hiddenEvents: events
      };

    onSearch(modifiedModel, dfltState?.paginationModel ?? paginationModel);
    };
    initializeState();
  }, []) 

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      hiddenEvents: hiddenEvents
    }))
  }, [hiddenEvents])

  useDidMountEffect(() => {
    sessionStorage.setItem("create-swarms-state", JSON.stringify({ filters, paginationModel }));
  }, [filters, paginationModel])

  const getEventsRef = useRef(null);

  async function onSearch(filters, paginationModel) {

    if(getEventsRef.current){
      getEventsRef.current.abort();
    }
    
    try {
      getEventsRef.current = getSwarmEvents({
        PageNo: paginationModel.page + 1, //A: our api start with 1
        RecordsLimit: paginationModel.pageSize,
        orderColumns: [{ Name: "name", orderType: "asc" }],
        filterColumns: createFilterColumns(filters),
        OnlyActiveSwarms: filters?.onlyActiveSwarms,
        OnlyFlaggedSwarms: filters?.onlyFlaggedSwarms
      })

      let res = await getEventsRef.current.unwrap();
      
      setLocalEvents(res.events);

      // * get swarms for events in order to update running states

      const bteIds = res.events.map(e => e.bteId);
      if(bteIds.length === 0) return;
      const bteIdsQueryString = bteIds.map(id => `bteId=${id}`).join('&');

      await getSwarms(`?${bteIdsQueryString}`).unwrap() // ! IMPORTANT do not ignore this query or you will get all DB's Swarms

    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      if (error.name === 'AbortError') {
        console.log('Request was cancelled');
      }
      throw error;
    }
  };

  
  const onShowHideEventClicked = async (e) => {
    try {
      await unhideEvents().unwrap();
      await onSearch({...filters, hiddenEvents: []}, paginationModel)
    } catch (error) {
      if (error.status == 401) return;
      throw error;
    }
  }

  return {
    filters,
    setFilters,
    paginationModel,
    setPaginationModel,
    hiddenEvents,
    onShowHideEventClicked,
    onSearch,
    loadingEvents,
    ErrorLoadingEvents,
    swarmEventsRes,
    errorGettingSwarms,
    swarmsQueryData
  }
}

export default useFilters;